/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TillSessionsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      tillSessions: this.store.findAll('finance/till-session'),
      tills: this.store.findAll('finance/till'),
      depositSlips: this.store.findAll('finance/deposit-slip'),
    });
  }
}
